import { Component, h } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import Icon from '../assets'
import BigCard from './assets/BigCard'
import SmallCard from './assets/SmallCard'

interface Props {
  controlUrl: string,
  title: string,
  selectedTemplate: number,
  onChange: (state: {title: string, selectedTemplate: number}) => void
}

interface State {
  title: string,
  contentIsExtended: boolean,
  templateIsExtended: boolean,
  selectedTemplateOption: number
}

export class CommunityCategoryWithHelp extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      title: props.title,
      contentIsExtended: false,
      templateIsExtended: true,
      selectedTemplateOption: props.selectedTemplate
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeTemplate = this.onChangeTemplate.bind(this)
    this.notifyChanges = this.notifyChanges.bind(this)
  }

  templateOptions = [{
    visual: <BigCard />,
    text: 'Big parent category card'
  }, {
    visual: <SmallCard />,
    text: 'Small parent category card'
  }]

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, this.notifyChanges)
  }

  onChangeTemplate (idx: number) {
    this.setState({ selectedTemplateOption: idx }, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange({ title: this.state.title, selectedTemplate: this.state.selectedTemplateOption })
  }

  render ({ controlUrl } : Props, { title, contentIsExtended, templateIsExtended, selectedTemplateOption }: State) {
    return (
      <div className='homepage-widget-configurator_tabs-wrapper'>
        <div className='homepage-widget-configurator_tab homepage-widget-configurator_tab-template'>
          <div className='homepage-widget-configurator_tab-header' onClick={() => this.setState({ templateIsExtended: !templateIsExtended })}>
            <div className='homepage-widget-configurator_tab-icon'>
              {
                templateIsExtended ? (
                  <Icon size={24} color='#2B3346' icon='chevronDown' />
                ) : <Icon size={24} color='#2B3346' icon='chevronRight' />
              }
            </div>
            TEMPLATE
          </div>
          {
            templateIsExtended ? (
              <div className='homepage-widget-configurator_tab-content'>
                {
                  this.templateOptions.map((option, id) => (
                    <div
                      className={`homepage-widget-configurator_template-option ${(id === selectedTemplateOption) ? 'checked' : ''}`}
                      onClick={() => this.onChangeTemplate(id)}
                    >
                      { option.visual }
                      <div>{ option.text }</div>
                      <Icon size={16} icon='checkbox' customClass='checkbox-icon' />
                    </div>
                  ))
                }
              </div>
            ) : null
          }
        </div>
        <div className='homepage-widget-configurator_tab homepage-widget-configurator_tab-content'>
          <div className='homepage-widget-configurator_tab-header' onClick={() => this.setState({ contentIsExtended: !contentIsExtended })}>
            <div className='homepage-widget-configurator_tab-icon'>
              {
                contentIsExtended ? (
                  <Icon size={24} color='#2B3346' icon='chevronDown' />
                ) : <Icon size={24} color='#2B3346' icon='chevronRight' />
              }
            </div>
            CONTENT
          </div>
          {
            contentIsExtended ? (
              <div className='homepage-widget-configurator_tab-content'>
                <InputGroup
                  title='Title'
                  type='text'
                  onChange={(e: ChangeEvent) => { this.onChangeTitle(e.target.value) }}
                  value={title} />
                <div className='widget-configuration_info-box'>
                  <strong>✨ How to edit community category card </strong>
                  <p> Please go to <a target='_blank' href={`${controlUrl}/settings/category/overview`}>community category overview in control</a> to reorder the categories. And in each parent category page, you can change title, description and visual (thumbnail image) for every card.</p>
                </div>
              </div>
            ) : null
          }
        </div>
      </div>
    )
  }
}

export default CommunityCategoryWithHelp

